import type { IconData } from '@stacksjs/iconify-core'

export const mailSearch: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M26 34.5a8.5 8.5 0 1 0 17 0a8.5 8.5 0 1 0-17 0M45 45l-4-4\"/><path d=\"M40.985 22.5Q41 21.306 41 20c0-5.895-.245-10.038-.48-12.656c-.19-2.125-1.84-3.724-3.967-3.885C33.657 3.24 28.903 3 22 3s-11.657.24-14.553.46C5.32 3.62 3.67 5.22 3.48 7.343C3.245 9.962 3 14.105 3 20s.245 10.038.48 12.656c.19 2.125 1.84 3.724 3.967 3.885c2.754.208 7.188.436 13.553.457\"/><path d=\"M3.25 14c1.172.531 13.372 6 18.75 6s17.579-5.47 18.75-6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mailSearch
